import { AppShellContent, Button, Headline, Icon, Text } from "@assetwatch/ui";
import { Link } from "@tanstack/react-router";
import { ProfileForm } from "../components/Profile/ProfileForm";
import { useProfileQuery } from "../queries/useProfileQuery";

export function ProfileScreen() {
  const query = useProfileQuery();
  if (query.isPending) return <AppShellContent pending>{null}</AppShellContent>;
  return (
    <AppShellContent>
      <div className="flex max-w-[760px] flex-col gap-(--spacing-16)">
        <div className="flex flex-col items-start gap-(--spacing-16)">
          <Button variant="ghost" size="sm" render={<Link to="/" />}>
            <Icon name="arrow-left" size="sm" />
            Back to General
          </Button>
          <Headline as="h1" size="lg" weight="bold">
            Profile Settings
          </Headline>
        </div>
        {query.data ? (
          <ProfileForm profile={query.data} />
        ) : (
          <div className="flex flex-col items-start gap-(--spacing-16)">
            <Text role="alert">Unable to load your profile. Try again.</Text>
            <Button variant="outline" onClick={() => void query.refetch()}>
              Retry
            </Button>
          </div>
        )}
      </div>
    </AppShellContent>
  );
}
